import React from "react"
import { graphql } from "gatsby"
import fancyTimeFormat from "../helper/fancyTime"
import Header from "../components/header"
import Layout from "../components/layout"
import YouTube from "react-youtube"

import slugify from "../helper/slugify"
import Seo from "../components/seo"

class VideoPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      player: null,
    }
  }

  // const [state, setState] = useState({
  //   start: data.videosJson.youtube.start,
  //   autoplay: 0,
  // })

  render() {
    // This function transforms an array of names into
    // a comma separated list of names with proper adding of "and".
    const arrayToCommaSeparatedString = arr => {
      return arr
        .map((el, i) => {
          if (i < arr.length - 1) {
            if (arr.length === 2) {
              return el + " "
            } else {
              return el + ", "
            }
          } else if (arr.length === 1) {
            return el + "."
          } else {
            return "and " + el + "."
          }
        })
        .join("")
    }

    const opts = {
      width: "100%",
      height: "100%",
      playerVars: {
        start: this.props.data.videosJson.youtube.start,
        autoplay: 0,
        rel: 0,
        color: "white",
      },
    }

    return (
      <Layout>
        <Seo title={this.props.data.videosJson.title} />
        <Header
          day={this.props.data.videosJson.day}
          pageTitle={this.props.data.videosJson.title}
        />
        <div className="flex justify-center">
          <div
            className="container max-w-3xl max-h-[900px]
          border-b border-darkcdfblue"
          >
            <div className="video w-full pt-[56%] relative overflow-hidden">
              <YouTube
                iframeClassName="w-full h-full absolute top-0 left-0 right-0 bottom-0"
                videoId={this.props.data.videosJson.youtube.link}
                opts={opts}
                onReady={this._onReady}
              />
            </div>
          </div>
        </div>
        {/* <Video
        videoSrcURL={this.props.data.videosJson.youtube.link}
        videoTitle={data.videosJson.title}
        videoStart={state.start}
        videoEnd={data.videosJson.youtube.end}
        autoplay={state.autoplay}
      /> */}
        <div
          className="p-5 max-w-3xl m-auto
      border-l border-darkcdfblue"
        >
          <h2 className="text-darkcdfblue font-mono mb-2">#Content:</h2>
          <span
            className="absolute w-full right-0 inline-block left-0
        border-t border-1 border-darkcdfblue"
          ></span>
          {this.props.data.videosJson.speaks.map((el, i) => (
            <div key={i} className="mb-10 mt-4">
              <h3
                id={slugify(el.title)}
                className="mb-0 border-b border-cdfblue"
              >
                {el.title} &ensp;
              </h3>
              <div
                className="flex place-content-between
            border-r border-cdfblue mb-5
            p-1"
              >
                <p className="text-gray-500 mb-0 font-mono inline font-semibold text-sm">
                  &gt; {el.speaker}
                </p>
                <button
                  className="text-orange-500 hover:opacity-80 font-mono
                  cursor-pointer mb-0 inline right-0 border-cdfblue text-sm
                  font-semibold"
                  onClick={() => {
                    this.changeTime(el.timecode)
                  }}
                  onKeyDown={() => {
                    this.changeTime(el.timecode)
                  }}
                >
                  &#9654;&nbsp;
                  <span className="underline">
                    {fancyTimeFormat(el.timecode)}
                  </span>
                </button>
              </div>
              {el.coauthors !== null && (
                <p className="font-sans text-gray-500 mt-0">
                  / This presentation is part of a joint work with{" "}
                  {arrayToCommaSeparatedString(el.coauthors)}
                </p>
              )}
              {el.slides !== null && (
                <a
                  href={
                    "https://app.box.com/index.php?rm=box_download_shared_file&shared_name=" +
                    el.slides[0] +
                    "&file_id=f_" +
                    el.slides[1]
                  }
                  className="border border-cdfblue p-3 font-mono text-orange-500
              mr-5 transition ease-in-out
              hover:bg-cdfblue hover:text-white underline
              visited:text-red-400"
                >
                  &#8599;Slides
                </a>
              )}
              {el.paper !== null && (
                <a
                  href={el.paper}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border border-cdfblue p-3 font-mono text-orange-500
              mr-5 transition ease-in-out
              hover:bg-cdfblue hover:text-white underline
              visited:text-red-400"
                >
                  &#8599;Paper
                </a>
              )}
            </div>
          ))}
        </div>
      </Layout>
    )
  }

  _onReady = event => {
    // access to player in all event handlers via event.target
    this.setState({
      player: event.target,
    })
    event.target.pauseVideo()
  }

  changeTime = timecode => {
    this.state.player.seekTo(timecode)
    this.state.player.playVideo()
  }
}

export default VideoPage

export const query = graphql`
  query ($id: String!) {
    videosJson(id: { eq: $id }) {
      title
      description
      day
      youtube {
        link
        start
        end
      }
      speaks {
        title
        speaker
        coauthors
        slides
        paper
        timecode
      }
    }
  }
`
